import intlTelInput from 'intl-tel-input'

const UTILS_SCRIPT = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js'

// Starts a phone picker with the house options. The picker fills the hidden field the form posts
// from utils.js on cdnjs; until that loads, getNumber() is "" and would post a blank over the typed
// number. This submit listener is added after the picker's own, so it runs second and fills a blank.
export default function startIntlPhone(input, options = {}) {
  // Phone keypad whatever type the view rendered; autocomplete stays the picker's "off" (autofill saves odd formats).
  input.setAttribute('inputmode', 'tel')

  const iti = intlTelInput(input, {
    utilsScript: UTILS_SCRIPT,
    separateDialCode: true,
    hiddenInput: input.dataset.hiddeninput,
    ...options
  })

  input.form?.addEventListener('submit', () => {
    if (iti.hiddenInput && !iti.hiddenInput.value) {
      iti.hiddenInput.value = withDialCode(input.value, iti.getSelectedCountryData().dialCode)
    }
  })
  return iti
}

// "+<dial code><digits>", as v2's phone_controller#addDialCode builds it. A +1 number goes up as
// typed: the server reads the mask's "(408) 555-1234" and drops a typed leading 1.
function withDialCode(value, dialCode) {
  const typed = value.trim()
  const digits = typed.replace(/\D/g, '')
  if (!digits) return ''
  if (typed.startsWith('+')) return `+${digits}`
  if (!dialCode || dialCode === '1') return typed

  return `+${dialCode}${digits}`
}
